import './App.css';
import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import 'dayjs/locale/pt-br';

import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {
  AlterarNaturezaDespesa, CadastrarClinicaCirast,
  CadastrarConcedente, CadastrarConsultaCirast, CadastrarConvenente, CadastrarTipoCirast, DetalheAtendimentoCirast,
  Forcas, ItemDetalhes,
  MetaDetalhes, MinhasDemandas, NovaConta, NovaDemanda,
  NovaFonteRecurso, NovaNaturezaDespesa,
  NovoProjeto, ProjetoDetalhes, RelatorioPagamentoCirast,
  Setores,
  UsuarioEditar,
  Usuarios,
  VisualizarDemanda
} from "./paginas";
import NovaMeta from "./paginas/meta/NovaMeta";
import ListarProjetosArquivados from "./paginas/projeto/listar-projetos-arquivados";
import Busca from "./paginas/Busca";
import CadastrarItemDemanda from "./paginas/demanda/CadastrarItemDemanda";
import ListaDemandasAsplan from "./paginas/demanda/lista-demandas-asplan";
import ListarConsultasCirast from "./paginas/cirast/ListarConsultasCirast";
import ImpressaoCirast from "./paginas/cirast/ImpressaoCirast";
import AtendimentoCirast from "./paginas/publica/AtendimentoCirast";
import ListarConsultasCirastAdm from "./paginas/cirast/ListarConsultasCirastAdm";
import MenuTopo from "./componentes/layout/menu-topo/menu-topo";
import {logado} from "./util/usuario-util";
import AtualizacaoMonetaria from "./paginas/conta/AtualizacaoMonetaria";
import DashboardAsplan from "./paginas/dashboard/dashboard-asplan";
import {AppShell, Burger, Group, MantineProvider, ScrollArea} from '@mantine/core';
import {DatesProvider} from '@mantine/dates';
import {TEMA} from './config/tema';
import MenuLateral from "./componentes/layout/menu-lateral/menu-lateral";
import Login from "./paginas/login";
import Principal from "./paginas/principal/principal";
import {ModalsProvider} from "@mantine/modals";
import ControleCirastPagina from "./paginas/cirast/controle-cirast-pagina";
import CadastrarCurso from "./paginas/curso/cadastrar-curso";
import InscricoesAbertas from "./paginas/curso/inscricoes-abertas";
import classes from "./App.module.css";
import {useState} from "react";
import Delegacias from "./paginas/delegacia/delegacias";

export default App;

function App() {
  const [mobile, setMobile] = useState(false)
  const [desktop, setDesktop] = useState(true)

  const routes =
      <Routes>
      <Route path="/" element={<Login/>}/>
      <Route path='/dashboard' element={<DashboardAsplan/>}/>
      <Route path="/busca" element={<Busca/>}/>
      <Route path="/principal" element={<Principal/>}/>
      <Route path="/usuario/:id" element={<UsuarioEditar/>}/>

      {/*NOVO*/}
      <Route path="/novo/novaConta" element={<NovaConta/>}/>
      <Route path="/novo/novaNaturezaDespesa" element={<NovaNaturezaDespesa/>}/>
      <Route path="/novo/novoConcedente" element={<CadastrarConcedente/>}/>
      <Route path="/novo/novoConvenente" element={<CadastrarConvenente/>}/>
      <Route path="/novo/projetos/novoProjeto" element={<NovoProjeto />}/>
      <Route path='/novo/novaFonteRecurso' element={<NovaFonteRecurso/>}/>

      {/*LISTAR*/}
      <Route path="/listar/usuario" element={<Usuarios/>}/>
      <Route path="/listar/forca" element={<Forcas/>}/>
      <Route path='/listar/delegacia' element={<Delegacias/>}/>
      <Route path="/listar/setores" element={<Setores/>}/>
      <Route path="/listar/projetosArquivados/listar" element={<ListarProjetosArquivados/>}/>

      {/*DEMANDA*/}
      <Route path="/dod/nova-demanda" element={<NovaDemanda/>}/>
      <Route path="/dod/minhasDemandas" element={<MinhasDemandas/>}/>
      <Route path="/dod/cadastrarItemDemanda" element={<CadastrarItemDemanda/>}/>
      <Route path="/dod/listagemDodAsplan" element={<ListaDemandasAsplan/>}/>
      <Route path="/visualizarDemanda/:id" element={<VisualizarDemanda/>}/>

      <Route path="/alterarNatureza/:id" element={<AlterarNaturezaDespesa/>}/>
      <Route path="/projeto/:id" element={<ProjetoDetalhes/>}/>
      <Route path="/projeto/:id/novaMeta" element={<NovaMeta/>}/>
      <Route path="/projeto/:idProjeto/meta/:idMeta" element={<MetaDetalhes/>}/>
      <Route path="/projeto/:idProjeto/meta/:idMeta/item/:idItem" element={<ItemDetalhes/>}/>

      {/*CURSO*/}
      <Route path='/curso/cadastrar-curso' element={<CadastrarCurso/>}/>
      <Route path='/curso/inscricoes-abertas' element={<InscricoesAbertas/>}/>

      {/*CIRAST*/}
      <Route path='/cirast/cadastrarConsultaCirast' element={<CadastrarConsultaCirast/>}/>
      <Route path='/cirast/configuracao-cirast' element={<ControleCirastPagina/>}/>
      <Route path='/cirast/listarConsultasCirast' element={<ListarConsultasCirast/>}/>
      <Route path='/cirast/listarConsultasAdm' element={<ListarConsultasCirastAdm/>}/>
      <Route path='/cirast/cadastrarClinicaCirast' element={<CadastrarClinicaCirast/>}/>
      <Route path='/cirast/relatorioPagamentoCirast' element={<RelatorioPagamentoCirast/>}/>
      <Route path='/cirast/cadastrarAtendimentoCirast' element={<CadastrarTipoCirast/>}/>
      <Route path='/impressaoCirast/:id' element={<ImpressaoCirast/>}/>
      <Route path='/detalheAtendimento/:id' element={<DetalheAtendimentoCirast/>}/>

      <Route path='/publica/atendimento-cirast/:id' element={<AtendimentoCirast/>}/>

      <Route path='/conta/:idConta/atualizacaoMonetaria' element={<AtualizacaoMonetaria/>}/>
    </Routes>

  return (
    <MantineProvider theme={TEMA} defaultColorScheme="light">
      <DatesProvider settings={{locale: 'pt-br', firstDayOfWeek: 0, weekendDays: [0]}}>
        <ModalsProvider>
          <Router>
            {!logado() ? routes : <AppShell
              layout="alt"
              header={{height: 60}}
              navbar={{
                width: 250,
                breakpoint: 'sm',
                collapsed: {mobile: !mobile, desktop: !desktop},
              }}
              padding="md"
              withBorder={false}
              transitionDuration={500}
              transitionTimingFunction="ease"
            >
              <AppShell.Header className={classes.header}>
                <Group h="100%" px="md">
                  <Burger
                    opened={mobile}
                    onClick={() => setMobile(!mobile)}
                    hiddenFrom="sm"
                    size="sm"
                    mr={6}
                    className={classes.burguer}
                  />
                  <Burger
                    opened={desktop}
                    onClick={() => setDesktop(!desktop)}
                    visibleFrom="sm"
                    size="md"
                    mr={6}
                    className={classes.burguer}
                  />
                </Group>
                <MenuTopo/>

              </AppShell.Header>

              <AppShell.Navbar p="md" className={classes.navbar}>
                <AppShell.Section grow component={ScrollArea}>

                  <MenuLateral setMobile={setMobile}/>

                </AppShell.Section>
                <AppShell.Section>Asplan</AppShell.Section>
              </AppShell.Navbar>

              <AppShell.Main bg={"#f4f6f9"} >
                {routes}
              </AppShell.Main>
            </AppShell>
            }
          </Router>
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  );
}
